import * as Actions from '../../actions'

const initialState = {
  data: {
    packageOrders: [], // for active package orders
    inShopOrders: [], // for active inShop orders
    pastOrders: {}, // for venues past orders (no seperateion of package and inShop)
    deliveredOrders: {
      grossTotal: 0,
      netTotal: 0,
      comissionTotal: 0,
      onlinePaymentTotal: 0,
      offlinePaymentTotal: 0,
      orders: []

    }, // for venues delivered orders (billing)
    userOrders: [], // for users orders
    allOrders: [] // for admin panel to show active orders of all vevnues
  },
  selected: {
    data: {},
    isLoading: false,
    error: false
  },
  isLoading: false,
  error: false
}

const order = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_ORDER:
    case Actions.SET_SELECTED_ORDER: {
      return {
        ...state,
        selected: {
          ...state.selected,
          isLoading: true
        }
      }
    }
    case Actions.GET_ORDER_SUCCESS:
    case Actions.SET_SELECTED_ORDER_SUCCESS: {
      return {
        ...state,
        selected: {
          data: action.payload,
          isLoading: false,
          error: false
        }
      }
    }
    case Actions.GET_ORDER_ERROR:
    case Actions.SET_SELECTED_ORDER_ERROR: {
      return {
        ...state,
        selected: {
          data: {},
          isLoading: false,
          error: action.error
        }
      }
    }

    case Actions.GET_ORDERS_OF_USER: {
      return {
        ...state,
        isLoading: true,
        error: false
      }
    }
    case Actions.GET_ORDERS_OF_USER_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          userOrders: action.payload
        },
        isLoading: false,
        error: false
      }
    }
    case Actions.GET_ORDERS_OF_USER_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    }

    case Actions.LOAD_MORE_ORDERS_OF_USER: {
      return {
        ...state,
        isLoading: true,
        error: false
      }
    }
    case Actions.LOAD_MORE_ORDERS_OF_USER_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          userOrders: {
            ...action.payload,
            docs: [...state.data.userOrders.docs, ...action.payload.docs]
          }
        },
        isLoading: false,
        error: false
      }
    }
    case Actions.LOAD_MORE_ORDERS_OF_USER_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    }

    case Actions.GET_ACTIVE_ORDERS_OF_VENUE: {
      return {
        ...state,
        isLoading: true,
        error: false
      }
    }

    case Actions.GET_ACTIVE_ORDERS_OF_VENUE_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload
        },
        isLoading: false,
        error: false
      }
    }
    case Actions.GET_ACTIVE_ORDERS_OF_VENUE_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    }

    case Actions.GET_PAST_ORDERS_OF_VENUE: {
      return {
        ...state,
        isLoading: true,
        error: false
      }
    }
    case Actions.GET_PAST_ORDERS_OF_VENUE_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          pastOrders: action.payload
        },
        isLoading: false,
        error: false
      }
    }
    case Actions.GET_PAST_ORDERS_OF_VENUE_ERROR: {
      return {
        ...state,
        data: {
          ...state.data,
          pastOrders: {}
        },
        isLoading: false,
        error: action.error
      }
    }
    case Actions.GET_PAST_USERS_ORDERS_OF_VENUE: {
      return {
        ...state,
        isLoading: true,
        error: false
      }
    }
    case Actions.GET_PAST_USERS_ORDERS_OF_VENUE_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          pastUsersOrders: action.payload
        },
        isLoading: false,
        error: false
      }
    }
    case Actions.GET_PAST_USERS_ORDERS_OF_VENUE_ERROR: {
      return {
        ...state,
        data: {
          ...state.data,
          pastUsersOrders: {}
        },
        isLoading: false,
        error: action.error
      }
    }
    case Actions.GET_ALL_ORDERS: {
      return {
        ...state,
        isLoading: true,
        error: false
      }
    }
    case Actions.GET_DELIVERED_ORDERS_OF_VENUE: {
      return {
        ...state,
        isLoading: true,
        error: false
      }
    }
    case Actions.GET_DELIVERED_ORDERS_OF_VENUE_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          deliveredOrders: action.payload
        },
        isLoading: false,
        error: false
      }
    }
    case Actions.GET_DELIVERED_ORDERS_OF_VENUE_ERROR: {
      return {
        ...state,
        data: {
          ...state.data,
          deliveredOrders: {
            grossTotal: 0,
            netTotal: 0,
            comissionTotal: 0,
            onlinePaymentTotal: 0,
            offlinePaymentTotal: 0,
            orders: []

          }
        },
        isLoading: false,
        error: action.error
      }
    }

    case Actions.GET_ALL_ORDERS_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          allOrders: action.payload
        },
        isLoading: false,
        error: false
      }
    }
    case Actions.GET_ALL_ORDERS_ERROR: {
      return {
        ...state,
        data: {
          ...state.data,
          allOrders: []
        },
        isLoading: false,
        error: action.error
      }
    }

    case Actions.PLACE_ORDER: {
      return {
        ...state,
        isLoading: true,
        error: false
      }
    }
    case Actions.PLACE_ORDER_SUCCESS: {
      if (action.payload.orderType === 'inShop') { state.data.inShopOrders = [...state.data.inShopOrders, action.payload] } else if (action.payload.orderType === 'package') {
        state.data.packageOrders = [
          ...state.data.packageOrders,
          action.payload
        ]
      }

      return {
        ...state,
        isLoading: false,
        error: false
      }
    }
    case Actions.PLACE_ORDER_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    }

    case Actions.UPDATE_ORDER:
    case Actions.APPROVE_ORDER:
    case Actions.REJECT_ORDER:
    case Actions.CANCEL_ORDER:
    case Actions.UNCANCEL_ORDER:
    case Actions.DISPATCH_ORDER:
    case Actions.UNDISPATCH_ORDER:
    case Actions.DELIVER_ORDER:
    case Actions.UNDELIVER_ORDER:
    case Actions.USE_POINT:
    case Actions.UNUSE_POINT:
    case Actions.ADD_ORDER_COMMENT:
    case Actions.DELETE_ORDER_COMMENT: {
      return {
        ...state,
        selected: {
          ...state.selected,
          isLoading: true,
          error: false
        },
        isLoading: true,
        error: false
      }
    }
    case Actions.UPDATE_ORDER_SUCCESS:
    case Actions.APPROVE_ORDER_SUCCESS:
    case Actions.REJECT_ORDER_SUCCESS:
    case Actions.CANCEL_ORDER_SUCCESS:
    case Actions.UNCANCEL_ORDER_SUCCESS:
    case Actions.DISPATCH_ORDER_SUCCESS:
    case Actions.UNDISPATCH_ORDER_SUCCESS:
    case Actions.DELIVER_ORDER_SUCCESS:
    case Actions.UNDELIVER_ORDER_SUCCESS:
    case Actions.USE_POINT_SUCCESS:
    case Actions.UNUSE_POINT_SUCCESS:
    {
      const newData =
        action.payload.orderType === 'inShop'
          ? [...state.data.inShopOrders]
          : [...state.data.packageOrders]
      let index     = newData.findIndex((o) => o._id === action.payload._id)
      newData.splice(index, 1, action.payload)

      if (action.payload.orderType === 'inShop') { state.data.inShopOrders = newData } else state.data.packageOrders = newData

      // update userOrders
      const newUserData = [...state.data.userOrders]
      index             = newUserData.findIndex((o) => o._id === action.payload._id)
      if (index !== -1) {
        newUserData.splice(index, 1, action.payload)
        state.data.userOrders = newUserData
      }

      return {
        ...state,
        // update selected order
        selected: {
          ...state.selected,
          data: { ...action.payload },
          isLoading: false,
          error: false
        },
        isLoading: false,
        error: false
      }
    }
    case Actions.UPDATE_ORDER_ERROR:
    case Actions.APPROVE_ORDER_ERROR:
    case Actions.REJECT_ORDER_ERROR:
    case Actions.CANCEL_ORDER_ERROR:
    case Actions.UNCANCEL_ORDER_ERROR:
    case Actions.DISPATCH_ORDER_ERROR:
    case Actions.UNDISPATCH_ORDER_ERROR:
    case Actions.DELIVER_ORDER_ERROR:
    case Actions.UNDELIVER_ORDER_ERROR:
    case Actions.USE_POINT_ERROR:
    case Actions.UNUSE_POINT_ERROR:
    case Actions.ADD_ORDER_COMMENT_ERROR:
    case Actions.DELETE_ORDER_COMMENT_ERROR: {
      return {
        ...state,
        selected: {
          ...state.selected,
          isLoading: false,
          error: action.error
        },
        isLoading: false,
        error: action.error
      }
    }

    case Actions.ADD_ORDER_COMMENT_SUCCESS:case Actions.DELETE_ORDER_COMMENT_SUCCESS: {
      return {
        ...state,
        selected: {
          ...state.selected,
          data: {
            ...state.selected.data,
            comments: [...action.payload.comments]
          },
          isLoading: false,
          error: false
        },
        isLoading: false,
        error: false
      }
    }

    case Actions.LOGOUT: {
      return {
        ...state,
        isLoading: true,
        error: false
      }
    }
    case Actions.LOGOUT_SUCCESS: {
      return initialState
      // {
      //   ...state,
      //   data: {
      //     packageOrders: [], // for active package orders
      //     inShopOrders: [], // for active inShop orders
      //     pastOrders: {}, // for venues past orders (no seperateion of package and inShop)
      //     userOrders: [], // for users orders
      //     allOrders: [], // for admin panel to show active orders of all vevnues
      //     deliveredOrders: {
      //       grossTotal:0,
      //       netTotal:0,
      //       comissionTotal:0,
      //       onlinePaymentTotal:0,
      //       offlinePaymentTotal: 0,
      //       orders: [],
      //     }
      //   },
      //   selected: {},
      //   isLoading: false,
      //   error: false,
      // };
    }
    case Actions.LOGOUT_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    }

    default: {
      return state
    }
  }
}

export default order
